import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

const sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true'

export const sentry = {
  install: function (app: App, { router }: { router: Router }): void {
    if (!sentryEnabled) {
      return
    }
    Sentry.init({
      app,
      dsn: 'https://9181e1dbfd9b4de9a0c903f98ba19026@o77796.ingest.sentry.io/5914554',
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracePropagationTargets: ['app.storyblok.com', /^\//],
      release: import.meta.env.VITE_SENTRY_RELEASE,
      tracesSampleRate: 0.01,
    })
  },
}
